import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"

import lobbyReducers from "../reducers"

export const thunk = createAsyncThunk("lobby/getLobbies", async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.get("/lobby/")
    return response.data
  } catch (error) {
    return rejectWithValue(error.response.data)
  }
})

export const onSucceed = lobbyReducers.setLobbies

const thunkObject = { thunk, onSucceed }
export default thunkObject
